import { Grid, Theme, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import LiquidCheckbox from '@src/components/LiquidCheckbox'
import useFormikHelper from '../../useFormikHelper'
import messages from '@src/routes/SemiConfigurators/messages'
import { makeStyles } from '@material-ui/core/styles'
import { useProductFromQueryParam } from '../../ProductsConfiguration'
import { TubeProperties } from '../../../../utils/enum'
import { TubeProduct } from '../../enum'

const useStyles = makeStyles((theme: Theme) => {
  return {
    headerText: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 700,
    },
    disabledText: {
      color: theme.palette.grey[300],
    },
    checkboxGrid: {
      paddingBlock: theme.spacing(0.5),
    },
    label: {
      marginLeft: theme.spacing(1),
    },
  }
})

const Services: React.FC<any> = () => {
  const product = useProductFromQueryParam()
  const classes = useStyles()
  const formik = useFormikHelper()
  const handleServiceChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    service: string
  ) => {
    const currentServices = formik.selectedOligoValues.additionalServices || []

    if (product === TubeProduct.iscaledna) {
      if (
        service === TubeProperties.SALT &&
        (formik.selectedOligoValues.purification === TubeProperties.HPLC ||
          formik.selectedOligoValues.purification === TubeProperties.DESALT)
      ) {
        return
      }
      if (
        (service === TubeProperties.SALT ||
          service === TubeProperties.FILTER) &&
        formik.selectedOligoValues.purification === TubeProperties.VIVO
      ) {
        return
      }
    }

    if (e.target.checked) {
      if (!currentServices.includes(service)) {
        formik.setOligoFieldValue(
          TubeProperties.AdditionalServices,
          [...currentServices, service],
          false
        )
        if (
          formik.allValues.applyToNextOligos &&
          formik.activeOligoIndex === 0
        ) {
          const updatedOligos = formik.allValues.oligoList.map((oligo) => ({
            ...oligo,
            additionalServices: [...currentServices, service],
          }))
          formik.setFieldValue('oligoList', updatedOligos, false)
        }
        formik.setOligoFieldValue('flag', 1, false)
      }
    } else {
      const updatedServices = currentServices.filter((s) => s !== service)
      if (formik.allValues.applyToNextOligos && formik.activeOligoIndex === 0) {
        const updatedOligos = formik.allValues.oligoList.map((oligo) => ({
          ...oligo,
          additionalServices: updatedServices,
        }))
        formik.setFieldValue('oligoList', updatedOligos, false)
      }
      if (
        product === TubeProduct.iscaledna &&
        ((formik.selectedOligoValues.purification === TubeProperties.VIVO &&
          updatedServices.length === 2) ||
          ((formik.selectedOligoValues.purification === TubeProperties.HPLC ||
            formik.selectedOligoValues.purification ===
              TubeProperties.DESALT) &&
            updatedServices.length === 1))
      ) {
        formik.setOligoFieldValue('flag', 0, false)
      }
      formik.setOligoFieldValue(
        TubeProperties.AdditionalServices,
        updatedServices,
        false
      )
    }
  }
  const listAllAdditionalServices = ['SALT', 'FILTER', 'ENDO']
  const sectionEnabled =
    formik.selectedOligoValues.sequence !== '' &&
    (!formik.errors || formik.errors?.sequence === '')

  const isServiceDisabled = (service) => {
    return (
      !sectionEnabled ||
      !formik.selectedOligoValues.enabledAdditionalServices?.includes(
        service
      ) ||
      !formik.selectedOligoValues.purification
    )
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} style={{ paddingTop: '24px', paddingBottom: '0px' }}>
        <Typography
          className={`${classes.headerText} ${!sectionEnabled ? classes.disabledText : ''}`}
          variant="h6"
        >
          <FormattedMessage id="SERVICES" defaultMessage="Services" />
        </Typography>
      </Grid>
      {listAllAdditionalServices.map((service) => {
        const disabled = isServiceDisabled(service)
        return (
          <Grid item xs={12} key={service} className={classes.checkboxGrid}>
            <LiquidCheckbox
              checked={
                !disabled &&
                (!!formik.selectedOligoValues.additionalServices?.includes(
                  service
                ) ||
                  ((formik.selectedOligoValues.purification ===
                    TubeProperties.HPLC ||
                    formik.selectedOligoValues.purification ===
                      TubeProperties.DESALT) &&
                    service === TubeProperties.SALT) ||
                  (formik.selectedOligoValues.purification ===
                    TubeProperties.VIVO &&
                    (service === TubeProperties.SALT ||
                      service === TubeProperties.FILTER)))
              }
              onChange={(e) => handleServiceChange(e, service)}
              label={
                <Typography
                  className={`${classes.label} ${!sectionEnabled ? classes.disabledText : ''}`}
                >
                  <FormattedMessage {...messages[`PC_SPEC_${service}`]} />
                </Typography>
              }
              disabled={disabled}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
export default Services
